<template>
  <div class="title">
    <h2>下载 mentech sports 手表离线地图</h2>
  </div>
  <div class="app-container">
    <div class="download-map">
      <h3 class="download-title">如何下载地图</h3>
    </div>

    <div class="app-title">
      <div class="title-box">
        <div class="title-box-text">
          <img src="../images/bulb.png" alt="bulb" />
          <span>
            将地图文件“下载”到电脑本地，使用数据线连接电脑和手表，将地图文件传输到手表中。
            <button class="title-button" @click="illustrateOpen = true">
              查看安装说明
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="map-table">
      <el-tabs type="card" :stretch="true" class="tabs-table">
        <el-tab-pane label="亚洲">
          <!-- 地图列表 -->
          <el-table
            :data="asiaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="欧洲">
          <!-- 地图列表 -->
          <el-table
            :data="europeTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="北美洲">
          <!-- 地图列表 -->
          <el-table
            :data="northAmericaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="南美洲">
          <!-- 地图列表 -->
          <el-table
            :data="southAmericaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="中美洲">
          <!-- 地图列表 -->
          <el-table
            :data="centralAmericaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="非洲">
          <!-- 地图列表 -->
          <el-table
            :data="africaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="南极洲">
          <!-- 地图列表 -->
          <el-table
            :data="antarcticaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>

        <el-tab-pane label="大洋洲">
          <!-- 地图列表 -->
          <el-table
            :data="oceaniaTableData"
            v-loading="loading"
            style="width: 100%; font-size: 16px"
          >
            <el-table-column prop="country" label="国家名" width="220px">
              <template #default="{ row }">
                {{ countryTranslations.get(row.country) }}
              </template>
            </el-table-column>
            <el-table-column prop="state" label="州名/省市" width="220px">
              <template #default="{ row }">
                {{ stateTranslations.get(row.state) }}
              </template>
            </el-table-column>
            <el-table-column prop="keyType" label="资源类型" width="220px">
              <template #default="{ row }">
                {{ keyType.get(row.keyType) }}
              </template>
            </el-table-column>
            <el-table-column prop="version" label="版本号" width="160px" />
            <el-table-column prop="utime" label="更新时间" width="220px" />
            <el-table-column fixed="right" label="操作" width="210px">
              <template #default="{ row }">
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="copyDownloadText(row)"
                >
                  复制下载链接
                </el-button>
                <el-button
                  link
                  type="primary"
                  size="small"
                  @click="handleDowload(row)"
                  >下载文件</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>

  <!-- 安装说明弹窗 -->
  <el-dialog v-model="illustrateOpen" width="1050px" append-to-body lock-scroll>
    <div class="content">
      <div class="content-title">
        <h2 style="text-align: center">安装说明</h2>
      </div>
      <div class="content-text">
        <p>1. 将下载的 rar压缩文件解压提取到当前位置</p>
        <img src="../images/illustrate_1.png" alt="illustrate_1" />
        <p>2. 将手表通过USB线插入计算机中，重启手表进入U盘模式，并等待"MENTECH"磁盘符出现。</p>
        <img src="../images/illustrate_2.png" alt="illustrate_2" />
        <p>3. 右键点击解压后的目录，选择复制。</p>
        <img src="../images/illustrate_3.png" alt="illustrate_3" />
        <p>4. 将复制后的文件粘贴到"MENTECH(E:)" > "MAP" > "map" 文件夹里。</p>
        <img src="../images/illustrate_4.png" alt="illustrate_4" />


        <div class="content-feater-box">
          <div class="content-feater-text">
            <p><strong>注意事项：</strong></p>
            <p>
              地图文件复制的时间比较长，如果使用笔记本注意提前将电源适配器接上，并将临时关闭休眠设置。
            </p>
            <!-- <p>2.[map]日录必须在根目录中，也不要对[map]目录重新命名。</p> -->
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import axios from "axios";
import { ElMessage } from "element-plus";
import { ref } from "vue";
const illustrateOpen = ref(false);
const loading = ref(false);

const tableData = ref([]);
const params = ref({
  page: 1,
  pageSize: 500,
});

const asiaTableData = ref([]);
const europeTableData = ref([]);
const northAmericaTableData = ref([]);
const southAmericaTableData = ref([]);
const centralAmericaTableData = ref([]);
const africaTableData = ref([]);
const antarcticaTableData = ref([]);
const oceaniaTableData = ref([]);

/**
 *
 * 国家名 检索
 *
 */
const countryTranslations = new Map([
  ["canada", "加拿大"],
  ["usa", "美国"],
  ["greenland", "绿地"],
  ["mexico", "墨西哥"],
  ["afghanistan", "阿富汗"],
  ["armenia", "亚美尼亚"],
  ["azerbaijan", "阿塞拜疆"],
  ["bangladesh", "孟加拉国"],
  ["bhutan", "不丹"],
  ["cambodia", "柬埔寨"],
  ["china", "中国"],
  ["east-timor", "东帝汶"],
  ["gcc-states", "海湾阿拉伯国家合作委员会"],
  ["india", "印度"],
  ["indonesia", "印度尼西亚"],
  ["iran", "伊朗"],
  ["iraq", "伊拉克"],
  ["israel-and-palestine", "以色列和巴勒斯坦"],
  ["japan", "日本"],
  ["jordan", "约旦"],
  ["kazakhstan", "哈萨克斯坦"],
  ["kyrgyzstan", "吉尔吉斯斯坦"],
  ["laos", "老挝"],
  ["lebanon", "黎巴嫩"],
  ["malaysia-singapore-brunei", "马来西亚新加坡文莱"],
  ["maldives", "马尔代夫"],
  ["mongolia", "蒙古"],
  ["myanmar", "缅甸"],
  ["nepal", "尼泊尔"],
  ["north-korea", "朝鲜"],
  ["pakistan", "巴基斯坦"],
  ["philippines", "菲律宾"],
  ["south-korea", "韩国"],
  ["sri-lanka", "斯里兰卡"],
  ["syria", "叙利亚"],
  ["taiwan", "中国台湾"],
  ["tajikistan", "塔吉克斯坦"],
  ["thailand", "泰国"],
  ["turkmenistan", "土库曼斯坦"],
  ["uzbekistan", "乌兹别克斯坦"],
  ["vietnam", "越南"],
  ["yemen", "也门"],
  ["albania", "阿尔巴尼亚"],
  ["andorra", "安道尔"],
  ["austria", "奥地利"],
  ["azores", "氮酮"],
  ["belarus", "白俄罗斯"],
  ["belgium", "比利时"],
  ["bosnia-herzegovina", "波斯尼亚和黑塞哥维那"],
  ["bulgaria", "保加利亚"],
  ["croatia", "克罗地亚"],
  ["cyprus", "塞浦路斯"],
  ["czech-republic", "捷克"],
  ["denmark", "丹麦"],
  ["england", "英格兰"],
  ["estonia", "爱沙尼亚"],
  ["faroe-islands", "法罗群岛"],
  ["finland", "芬兰"],
  ["france", "法国"],
  ["georgia", "格鲁吉亚"],
  ["germany", "德国"],
  ["greece", "希腊"],
  ["guernsey", "根西岛"],
  ["hungary", "匈牙利"],
  ["iceland", "冰岛"],
  ["ireland-and-northern-ireland", "爱尔兰和北爱尔兰"],
  ["isle-of-man", "马恩岛"],
  ["italy", "意大利"],
  ["kosovo", "科索沃"],
  ["latvia", "拉脱维亚"],
  ["liechtenstein", "列支敦士登"],
  ["lithuania", "立陶宛"],
  ["luxembourg", "卢森堡"],
  ["macedonia", "马其顿"],
  ["malta", "马耳他"],
  ["moldova", "摩尔多瓦"],
  ["monaco", "摩纳哥"],
  ["montenegro", "黑山共和国"],
  ["netherlands", "荷兰"],
  ["norway", "挪威"],
  ["poland", "波兰"],
  ["portugal", "葡萄牙"],
  ["romania", "罗马尼亚"],
  ["russia", "俄罗斯联邦"],
  ["scotland", "苏格兰"],
  ["serbia", "塞尔维亚"],
  ["slovakia", "斯洛伐克"],
  ["slovenia", "斯洛文尼亚"],
  ["spain", "西班牙"],
  ["sweden", "瑞典"],
  ["switzerland", "瑞士"],
  ["turkey", "土耳其共和国"],
  ["ukraine", "乌克兰"],
  ["wales", "威尔士"],
  ["argentina", "阿根廷"],
  ["bolivia", "玻利维亚"],
  ["brazil", "巴西"],
  ["chile", "智利"],
  ["colombia", "哥伦比亚"],
  ["ecuador", "厄瓜多尔"],
  ["guyana", "圭亚那"],
  ["paraguay", "巴拉圭"],
  ["peru", "秘鲁"],
  ["suriname", "苏里南"],
  ["uruguay", "乌拉圭"],
  ["venezuela", "委内瑞拉"],
  ["bahamas", "巴哈马群岛"],
  ["belize", "贝利泽"],
  ["cayman-islands", "开曼群岛"],
  ["costa-rica", "哥斯达黎加"],
  ["cuba", "古巴"],
  ["el-salvador", "萨尔瓦多"],
  ["guatemala", "危地马拉"],
  ["haiti-and-domrep", "海地和多米尼加共和国"],
  ["honduras", "洪都拉斯"],
  ["jamaica", "牙买加"],
  ["nicaragua", "尼加拉瓜"],
  ["panama", "巴拿马"],
  ["algeria", "阿尔及利亚"],
  ["angola", "安哥拉"],
  ["benin", "贝宁王国"],
  ["botswana", "博茨瓦纳"],
  ["burkina-faso", "布基纳法索"],
  ["burundi", "布隆迪"],
  ["cameroon", "喀麦隆"],
  ["canary-islands", "加那利群岛"],
  ["cape-verde", "佛得角共和国"],
  ["central-african-republic", "中非共和国"],
  ["chad", "乍得共和国"],
  ["comores", "科摩罗"],
  ["congo-brazzaville", "刚果共和国"],
  ["congo-democratic-republic", "刚果民主共和国"],
  ["djibouti", "吉布提"],
  ["egypt", "埃及"],
  ["equatorial-guinea", "赤道几内亚"],
  ["eritrea", "厄立特里亚"],
  ["ethiopia", "埃塞俄比亚"],
  ["gabon", "加蓬共和国"],
  ["ghana", "加纳共和国"],
  ["guinea-bissau", "几内亚比绍共和国"],
  ["guinea", "几内亚共和国"],
  ["ivory-coast", "科特迪瓦"],
  ["kenya", "肯尼亚"],
  ["lesotho", "莱索托"],
  ["liberia", "利比里亚"],
  ["libya", "利比亚"],
  ["madagascar", "马达加斯加"],
  ["malawi", "马拉维"],
  ["mali", "马里"],
  ["mauritania", "毛里塔尼亚"],
  ["mauritius", "毛里求斯"],
  ["morocco", "摩洛哥"],
  ["mozambique", "莫桑比克"],
  ["namibia", "纳米比亚"],
  ["nigeria", "尼日利亚"],
  ["niger", "尼日尔"],
  ["rwanda", "卢旺达"],
  ["saint-helena-ascension-and-tristan-da-cunha"],
  ["圣赫勒拿、‌阿森松和特里斯坦-达库尼亚"],
  ["sao-tome-and-principe", "圣多美和普林西比民主共和国"],
  ["senegal-and-gambia", "塞内加尔和冈比亚"],
  ["seychelles", "塞舌尔群岛"],
  ["sierra-leone", "塞拉利昂"],
  ["somalia", "索马里"],
  ["south-africa", "南非"],
  ["south-sudan", "南苏丹"],
  ["sudan", "苏丹"],
  ["swaziland", "斯威士兰"],
  ["tanzania", "坦桑尼亚"],
  ["togo", "多哥共和国"],
  ["tunisia", "突尼斯"],
  ["uganda", "乌干达"],
  ["zambia", "赞比亚"],
  ["zimbabwe", "津巴布韦"],
  ["antarctica", "南极洲"],
  ["american-oceania", "美国大洋洲"],
  ["australia", "澳大利亚"],
  ["cook-islands", "库克群岛"],
  ["fiji", "斐济"],
  ["ile-de-clipperton", "克利珀顿"],
  ["kiribati", "基里巴提"],
  ["marshall-islands", "马绍尔群岛"],
  ["micronesia", "密克罗尼西亚"],
  ["nauru", "瑙鲁"],
  ["new-caledonia", "新喀里多尼亚"],
  ["new-zealand", "新西兰"],
  ["niue", "纽埃岛"],
  ["palau", "帕劳共和国"],
  ["papua-new-quinea", "巴布亚新几内亚"],
  ["pitcairn-islands", "皮特凯恩群岛"],
  ["polynesie-francaise", "法属玻利尼西亚"],
  ["samoa", "萨摩亚"],
  ["solomon-islands", "所罗门群岛"],
  ["tokelau", "托克劳"],
  ["tonga", "汤加王国"],
  ["tuvalu", "图瓦卢"],
  ["vanuatu", "瓦努阿图"],
  ["wallis-et-futuna", "富图纳群岛"],
  ["papua-new-guinea", "巴布亚新几内亚"],
]);

/**
 *
 * 省市/州 检索
 *
 */
const stateTranslations = new Map([
  ["anhui", "安徽"],
  ["beijing", "北京"],
  ["chongqing", "重庆"],
  ["fujian", "福建"],
  ["gansu", "甘肃"],
  ["guangdong", "广东"],
  ["guangxi", "广西"],
  ["guizhou", "贵州"],
  ["hainan", "海南"],
  ["hebei", "河北"],
  ["henan", "河南"],
  ["hongkong", "香港"],
  ["hubei", "湖北"],
  ["hunan", "湖南"],
  ["inner-mongolia", "内蒙古"],
  ["jiangsu", "江苏"],
  ["jiangxi", "江西"],
  ["jilin", "吉林"],
  ["liaoning", "辽宁"],
  ["macau", "澳门"],
  ["ningxia", "宁夏"],
  ["qinghai", "青海"],
  ["shaanxi", "陕西"],
  ["shandong", "山东"],
  ["shanghai", "上海"],
  ["shanxi", "山西"],
  ["sichuan", "四川"],
  ["taiwan", "台湾"],
  ["tianjin", "天津"],
  ["xinjiang", "新疆"],
  ["xizang", "西藏"],
  ["yunnan", "云南"],
  ["zhejiang", "浙江"],
  ["heilongjiang", "黑龙江"],
  ["java", "爪哇岛"],
  ["kalimantan", "加里曼丹岛"],
  ["maluku", "马鲁古省"],
  ["nusa-tenggara", "东努沙登加拉省"],
  ["papua", "巴布亚省"],
  ["sulawesi", "苏拉威西岛"],
  ["sumatra", "苏门答腊岛"],
  ["chubu", "中部地区"],
  ["chugoku", "山阴山阳地区"],
  ["hokkaido", "北海道"],
  ["kansai", "关西"],
  ["kanto", "关东"],
  ["kyushu", "九州"],
  ["shikoku", "四国岛"],
  ["tohoku", "仙台市"],
  ["alsace", "阿尔萨斯"],
  ["aquitaine", "阿基坦"],
  ["auvergne", "奥弗涅"],
  ["basse-normandie", "下诺曼底大区"],
  ["bourgogne", "勃艮第"],
  ["bretagne", "布列塔尼"],
  ["centre", "中央大区"],
  ["champagne", "香槟区"],
  ["corse", "科西嘉大区"],
  ["franche", "弗朗什孔泰大区"],
  ["haute-normandie", "上诺曼底大区"],
  ["ile-de-france", "法兰西岛大区"],
  ["languedoc-roussillon", "朗格多克-鲁西荣大区"],
  ["limousin", "利穆赞大区"],
  ["lorraine", "洛林大区"],
  ["midi-pyrenees", "南部-比利牛斯模象大区"],
  ["nord-pas-de-calais", "北部-加来海峡大区"],
  ["pays-de-la-loire", "卢瓦尔河地区大区"],
  ["picardie", "皮卡第大区"],
  ["poitou-charentes", "普瓦图-夏朗德大区"],
  ["provence-alpes-cote-d-azur", "普罗旺斯-阿尔卑斯-蓝色海岸大区"],
  ["rhone-alpes", "圣艾蒂安"],
  ["arnsberg-regbez", "阿恩斯贝格市"],
  ["berlin", "柏林市"],
  ["brandenburg", "勃兰登堡州"],
  ["bremen", "不来梅市"],
  ["detmold-regbez", "代特莫尔德"],
  ["duesseldorf-regbez", "杜塞尔多夫市"],
  ["freiburg-regbez", "弗莱贝格"],
  ["hamburg", "汉堡市"],
  ["hessen", "黑森州"],
  ["karlsruhe-regbez", "卡尔斯鲁厄"],
  ["koeln-regbez", "科隆地区"],
  ["mecklenburg-vorpommern", "梅克伦堡-前波美拉尼亚州"],
  ["mittelfranken", "中弗兰肯行政区"],
  ["muenster-regbez", "明斯特市"],
  ["niederbayern", "下巴伐利亚行政区"],
  ["niedersachsen", "下萨克森州"],
  ["oberbayern", "上巴伐利亚行政区"],
  ["oberfranken", "上弗兰肯行政区"],
  ["oberpfalz", "诺伊马克特县"],
  ["rheinland-pfalz", "莱茵兰-普法尔茨州"],
  ["saarland", "萨尔兰州"],
  ["sachsen-anhalt", "萨克森-安哈尔特州"],
  ["sachsen", "萨克森自由州"],
  ["schleswig-holstein", "石勒苏益格-荷尔斯泰因州"],
  ["schwaben", "施瓦本地区"],
  ["stuttgart-regbez", "斯图加特"],
  ["thueringen", "图林根州"],
  ["tuebingen-regbez", "图宾根地区"],
  ["unterfranken", "下弗兰肯行政区"],
  ["centro", "中部地区"],
  ["isole", "伊奥利亚群岛"],
  ["nord-est", "东北部地区"],
  ["nord-ovest", "西北部地区"],
  ["sud", "南部地区"],
  ["drenthe", "德伦特省"],
  ["flevoland", "弗莱福兰省"],
  ["friesland", "弗里斯兰省"],
  ["gelderland", "格尔德兰"],
  ["groningen", "格罗宁根"],
  ["limburg", "林堡省"],
  ["noord-brabant", "北布拉班特"],
  ["noord-holland", "北荷兰省"],
  ["overijssel", "上艾瑟尔省"],
  ["utrecht", "乌得勒支省"],
  ["zeeland", "泽兰省"],
  ["zuid-holland", "南荷兰省"],
  ["dolnoslaskie", "下西里西亚省"],
  ["kujawsko-pomorskie", "库亚维-波美拉尼亚省"],
  ["lodzkie", "罗兹省"],
  ["lubelskie", "卢布林省"],
  ["lubuskie", "卢布斯卡省"],
  ["malopolskie", "小波兰地区"],
  ["mazowieckie", "马佐夫舍省"],
  ["opolskie", "奥波莱省"],
  ["podkarpackie", "喀尔巴阡山省"],
  ["podlaskie", "波德拉斯省"],
  ["pomorskie", "波美拉尼亚省"],
  ["slaskie", "下西里西亚省"],
  ["swietokrzyskie", "圣十字省"],
  ["warminsko-mazurskie", "瓦尔米亚马祖尔省"],
  ["wielkopolskie", "大波兰省"],
  ["zachodniopomorskie", "西滨海省"],
  ["central-fed-district", "中央联邦管区"],
  ["crimean-fed-district", "南部联邦管区"],
  ["far-eastern-fed-district", "远东联邦管区"],
  ["kaliningrad", "加里宁格勒州"],
  ["north-caucasus-fed-district", "北高加索联邦管区"],
  ["northwestern-fed-district", "西北联邦管区"],
  ["siberian-fed-district", "乌拉尔联邦管区"],
  ["south-fed-district", "南部联邦区"],
  ["ural-fed-district", "乌拉尔联邦管区"],
  ["volga-fed-district", "伏尔加联邦区"],
  ["andalucia", "安达卢西亚"],
  ["aragon", "阿拉贡自治区"],
  ["asturias", "阿斯图里亚斯自治区"],
  ["cantabria", "坎塔布里亚大区"],
  ["castilla-la-mancha", "卡斯蒂利亚-拉曼恰"],
  ["castilla-y-leon", "卡斯蒂利亚－莱昂"],
  ["cataluna", "拉科鲁尼亚"],
  ["ceuta", "休达自治市"],
  ["extremadura", "埃斯特雷马杜拉自治区"],
  ["galicia", "加利西亚"],
  ["islas-baleares", "巴利阿里群岛"],
  ["la-rioja", "里奥哈区"],
  ["madrid", "马德里"],
  ["melilla", "梅利利亚"],
  ["murcia", "穆尔西亚"],
  ["navarra", "纳瓦拉"],
  ["pais-vasco", "巴斯克产区"],
  ["valencia", "瓦伦西亚"],
  ["alberta", "阿尔伯塔省"],
  ["british-columbia", "不列颠哥伦比亚省"],
  ["manitoba", "曼尼托巴省"],
  ["new-brunswick", "新不伦瑞克省"],
  ["newfoundland-and-labrador", "纽芬兰与拉布拉多省"],
  ["northwest-territories", "西北地区"],
  ["nova-scotia", "新斯科舍省"],
  ["nunavut", "努纳武特地区"],
  ["ontario", "安大略省"],
  ["prince-edward-island", "爱德华王子岛省"],
  ["quebec", "魁北克市"],
  ["saskatchewan", "萨斯喀彻温省"],
  ["yukon", "育空地区"],
  ["alabama", "阿拉巴马州"],
  ["alaska", "阿拉斯加州"],
  ["arizona", "亚利桑那州"],
  ["arkansas", "阿肯色州"],
  ["colorado", "科罗拉多州"],
  ["connecticut", "康涅狄格州"],
  ["delaware", "特拉华州"],
  ["district-of-columbia", "华盛顿哥伦比亚特区"],
  ["florida", "佛罗里达州"],
  ["georgia", "佐治亚州"],
  ["hawaii", "夏威夷州"],
  ["idaho", "爱达荷州"],
  ["illinois", "伊利诺伊州"],
  ["indiana", "印第安纳州"],
  ["iowa", "艾奥瓦州"],
  ["kansas", "堪萨斯州"],
  ["kentucky", "肯塔基州"],
  ["louisiana", "路易斯安那州"],
  ["maine", "缅因州"],
  ["maryland", "马里兰州"],
  ["massachusetts", "马萨诸塞州"],
  ["michigan", "密歇根州"],
  ["minnesota", "明尼苏达州"],
  ["mississippi", "密西西比州"],
  ["missouri", "密苏里州"],
  ["montana", "蒙大拿州"],
  ["nebraska", "内布拉斯加州"],
  ["nevada", "内华达州"],
  ["new-hampshire", "新罕布什尔州"],
  ["new-jersey", "新泽西州"],
  ["new-mexico", "新墨西哥州"],
  ["new-york", "纽约州"],
  ["norcal", "北加利福尼亚地区"],
  ["north-carolina", "北卡罗来纳州"],
  ["north-dakota", "北达科他州"],
  ["ohio", "俄亥俄州"],
  ["oklahoma", "俄克拉荷马州"],
  ["oregon", "俄勒冈州"],
  ["pennsylvania", "宾夕法尼亚州"],
  ["puerto-rico", "波多黎各自由邦"],
  ["rhode-island", "罗得岛州"],
  ["socal", "南加利福尼亚地区"],
  ["south-carolina", "南卡罗来纳州"],
  ["south-dakota", "南达科他州"],
  ["tennessee", "田纳西州"],
  ["texas", "得克萨斯州"],
  ["us-virgin-islands", "美属维尔京群岛"],
  ["utah", "犹他州"],
  ["vermont", "佛蒙特州"],
  ["virginia", "弗吉尼亚州"],
  ["washington", "华盛顿州"],
  ["west-virginia", "西弗吉尼亚州"],
  ["wisconsin", "威斯康星州"],
  ["wyoming", "怀俄明州"],
  ["centro-oeste", "中西部地区"],
  ["nordeste", "东北部地区"],
  ["norte", "北里奥格兰德州"],
  ["sudeste", "东南部地区"],
  ["sul", "南部地区"],
]);

/**
 *
 * 资源类型分类
 *
 */
const keyType = new Map([
  ["1", "地貌图"],
  ["2", "等高线"],
]);

/**
 *
 * 获取列表
 *
 */
function getList() {
  axios
    .post(
      // "https://maps.mentech.jiaiot.net/jiaiot/api/v1/system/map/list",  // #开发
      "https://map.sports.mentech.com/sports/api/v1/system/map/list", // #生产
      params.value
    )
    .then((response) => {
      tableData.value = response.data.data;
      groupedItems();
    })
    .finally(() => {});
}

/**
 *
 * 列表分组
 *
 */
function groupedItems() {
  for (let i = 0; i < tableData.value.length; i++) {
    switch (tableData.value[i].continent) {
      case "asia":
        asiaTableData.value.push(tableData.value[i]);
        break;
      case "europe":
        europeTableData.value.push(tableData.value[i]);
        break;
      case "north-america":
        northAmericaTableData.value.push(tableData.value[i]);
        break;
      case "south-america":
        southAmericaTableData.value.push(tableData.value[i]);
        break;
      case "central-america":
        centralAmericaTableData.value.push(tableData.value[i]);
        break;
      case "africa":
        africaTableData.value.push(tableData.value[i]);
        break;
      case "antarctica":
        antarcticaTableData.value.push(tableData.value[i]);
        break;
      case "oceania":
        oceaniaTableData.value.push(tableData.value[i]);
        break;
      default:
        console.log("未找到分类");
        break;
    }
  }
}

/**
 *
 * 下载文件
 *
 */
const downloadText = ref("");
// 复制下载链接
function copyDownloadText(row) {
  const params = row.downloadUrl;
  axios
    .post(
      // `https://maps.mentech.jiaiot.net/jiaiot/api/v1/system/map/copy-download-link?downloadUrl=${params}`  // #开发
      `https://map.sports.mentech.com/sports/api/v1/system/map/copy-download-link?downloadUrl=${params}` // #生产
    )
    .then((res) => {
      downloadText.value = res.data.data.url;
      const input = document.createElement("input");
      input.value = downloadText.value;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      ElMessage({
        message: "链接复制成功",
        grouping: true,
        type: "success",
      });
      console.log("链接已复制到剪贴板", downloadText.value);
    });
}

// 直接下载地图文件
function handleDowload(row) {
  const params = row.downloadUrl;

  axios
    .post(
      // `https://maps.mentech.jiaiot.net/jiaiot/api/v1/system/map/copy-download-link?downloadUrl=${params}`  // #开发
      `https://map.sports.mentech.com/sports/api/v1/system/map/copy-download-link?downloadUrl=${params}` // #生产
    )
    .then((res) => {
      const link = document.createElement("a");
      link.href = res.data.data.url;
      link.style.display = "none";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
}

getList();
</script>

<style scoped>
a {
  text-decoration: none;
  color: #3070ff;
}

.app-container {
  width: 1250px;
  height: 500px;
  margin: 0 auto;
  padding-top: 15px;
}

.app-title {
  font-size: 18px;
}

.app-title h3 {
  position: relative;
  margin-left: 10px;
}

.app-title h3::before {
  content: "";
  width: 3px;
  height: 20px;
  background-color: #3b7eff;
  position: absolute;
  left: -10px;
  top: 50%;
  margin-top: -9px;
}

.title-box {
  width: 100%;
  height: 66px;
  background-color: #f1f4fa;
  border-radius: 10px;
  margin: 15px 0;
}

.title-box .title-box-text {
  position: absolute;
}

.title-box .title-box-text .title-button {
  background: none; /* 清除背景 */
  color: #3070ff; /* 文字颜色继承父元素 */
  border: none; /* 清除边框 */
  padding: 0; /* 清除内边距 */
  margin: 0; /* 清除外边距 */
  font: inherit; /* 字体样式继承父元素 */
  cursor: pointer; /* 鼠标样式为指针 */
}

.title-box .title-box-text img {
  position: relative;
  top: 4px;
  height: 20px;
  margin-left: 20px;
  line-height: 66px;
}

.title-box .title-box-text span {
  margin-left: 15px;
  line-height: 66px;
}

.content {
  width: 100%;
  height: 900px;
  color: #000;
}

.content-title {
  height: 5%;
}

.content-text {
  height: 95%;
  overflow: auto;
  font-size: 18px;
  padding: 0 20px;
}

.content-text p {
  margin-bottom: 15px;
}

.content img {
  width: 100%;
  margin-bottom: 30px;
}

.content-feater-box {
  width: 100%;
  height: 110px;
  background-color: #f1f4fa;
  border-radius: 10px;
}

.content-feater-text {
  padding: 15px;
}

.map-table {
  margin-bottom: 20px;
}
</style>
